import { Component, computed, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { BillingStateService } from '@app/core/services/billing-state.service';
import { BillingBanner, describeBillingBanner } from '@app/core/utils/billing-display';

// One banner for every billing state worth interrupting for (trial running, payment failed, trial
// ended, unpaid, cancelled). What each one says lives in billing-display.ts so the Billing page
// and this banner never disagree. Shows nothing for an active subscription, or for a workshop
// that is not billed.
@Component({
  selector: 'app-billing-banner',
  standalone: true,
  imports: [RouterLink],
  template: `
    @if (banner(); as b) {
      <div
        role="status"
        class="flex flex-wrap items-center gap-3 px-4 py-2.5 text-sm font-medium shadow-md"
        [class]="toneClass(b)"
      >
        <i class="pi text-base" [class]="iconClass(b)"></i>
        <span>{{ b.message }}</span>
        <a routerLink="/app/billing" class="ml-auto font-semibold underline whitespace-nowrap"
          >View billing</a
        >
      </div>
    }
  `,
})
export class BillingBannerComponent {
  private readonly state = inject(BillingStateService);

  protected readonly banner = computed(() => describeBillingBanner(this.state.billing()));

  protected toneClass(banner: BillingBanner): string {
    switch (banner.severity) {
      case 'info':
        return 'bg-sky-100 text-sky-900';
      case 'warn':
        return 'bg-amber-500 text-amber-950';
      case 'error':
        return 'bg-red-600 text-white';
    }
  }

  protected iconClass(banner: BillingBanner): string {
    return banner.severity === 'info' ? 'pi-info-circle' : 'pi-exclamation-triangle';
  }
}
